import React from "react";
import { Upload } from "antd";

import { useNotification } from "components/use-hooks";
import PhotoSourceUpload from "./photo-source-upload";


const UploadFile = ({
        variables = {},
        uploadMutation = () => {},
        loading,
        extraClass = "",
        accept = 'image/*',
        chooseSource = false,
        children
    }) => {

    const { nError } = useNotification();
    const UploadComponent = chooseSource ? PhotoSourceUpload : Upload;

    const uploadProps = {
        className: extraClass,
        disabled: loading,
        accept: accept,
        showUploadList: false,
        beforeUpload: (file) => {

            let uploadVar;

            if(variables.input !== undefined){
                uploadVar = { ...variables };
                uploadVar.input.file = file;
            } else {
                uploadVar = { ...variables, file }
            }

            uploadMutation({
                variables: {
                    ...uploadVar
                }
            }).catch((error) => nError( error ));

            return false;
        },

    };

    return(
        <UploadComponent {...uploadProps}>
            { children }
        </UploadComponent>
    );
};


export default UploadFile;
